<template>
  <div id="admin-container" class="wrapper">
    <div class="inner-wrap">
      <HotTable :root="root" ref="ocrTable" :settings="hotSettings"></HotTable>
    </div>
  </div>
</template>

<script>
  /* global $, algoliasearch */
  import HotTable from 'vue-handsontable-official'

  export default {
    data: function () {
      return {
        root: 'ocr-table',
        userLoggedIn: false,
        userIsAdmin: this.$globals.userRole == 'admin',
        ocrs: [],
        searchLimit: 5000,
        pageLimit: 1500,
        hotSettings: {
          data: this.ocrs,
          rowHeaders: true,
          stretchH: 'all',
          autoWrapRow: true,
          className: 'htCenter htMiddle',
          columnSorting: true,
          sortIndicator: true,
          observeChanges: false,
          contextMenu: false,
          colHeaders: ['Object ID', 'User ID', 'Username', 'Text', 'Timestamp', 'Duration (s)', 'OCR Process Time (s)', 'Local Time (s)', 'Filesize (MB)', 's/MB'],
          rowHeights: 50,
          colWidths: [120, 200, 200, 250, 150, 100, 130, 120, 100, 100],
          columns: [
            {data: 'objectID', readOnly: true, type: 'numeric'},
            {data: 'userID', readOnly: true, type: 'numeric'},
            {data: 'username', readOnly: true, type: 'text'},
            {data: 'text', type: 'text'},
            {data: 'timestamp', readOnly: true},
            {data: 'duration', readOnly: true},
            {data: 'ocrProcessTime', readOnly: true},
            {data: 'localTime', readOnly: true},
            {data: 'filesize', readOnly: true, type: 'text'},
            {data: 'mbPerSec', readOnly: true}
          ]
        }
      }
    },
    name: 'grapesAdmin',
    components: {
      HotTable
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.userLoggedIn = true
        } else {
          vm.userLoggedIn = false
        }
      })
      vm.$globals.isAdmin = true
      vm.showLoading()
      vm.getOCRs()
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      getOCRs: function () {
        let vm = this
        vm.ocrs = []
        var client = algoliasearch('BLP5M7YD97', 'e43146fabb439a15a2622c0264710cb6')
        var index = client.initIndex('OCRUploads')
        var query = vm.ocrQuery
        index.search({
          query: query,
          hitsPerPage: vm.searchLimit
        }).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var results = responses.hits
          console.log('number of results: ' + results.length)
          for (var i = 0; i < results.length; i++) {
            var obj = results[i]
            var duration = obj.duration
            var processTime = obj.ocrProcessTime
            var timestamp = obj.timestamp
            var filesize = (obj.filesize / 1048576).toFixed(1)
            var mbPerSec = parseFloat((duration * 1e-3) / filesize)
            obj.localTime = ((duration - processTime) / 1000).toFixed(1)
            if (duration) {
              obj.duration = (duration / 1000).toFixed(1)
            }
            if (processTime) {
              obj.ocrProcessTime = (processTime / 1000).toFixed(1)
            }
            if (filesize) {
              obj.filesize = filesize
            }
            if (timestamp) {
              obj.timestamp = new Date(timestamp).toUTCString()
            }
            obj.mbPerSec = mbPerSec.toFixed(1)
            vm.ocrs.push(obj)
          }
          /* Load Data */
          vm.$refs.ocrTable.table.loadData(vm.ocrs)
          setTimeout(function () {
            vm.hideLoading()
          }, 1000)
        })
      }
    }
  };
</script>

<style>
  .table-filter {
    padding: 10px 0;
  }
  .table-filter input {
    height: 40px;
    width: 300px;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .table-filter .pure-button {
    vertical-align: top;
  }
  #ocr-table {
    width: 100%;
    height: 100vh;
    height: calc(100vh - 55px);
    margin-top: 4px;
    overflow: hidden;
  }
  #ocr-table th {
    vertical-align: middle;
  }
  #ocr-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #ocr-table thead th .relative {
    padding: 4px 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/ocrAdmin.vue